import React, { useState, useEffect, useRef } from 'react';

const MenuBar = ({ menu, window, onMenuClick }) => {
	const [openMenu, setOpenMenu] = useState(null);
	const barRef = useRef(null);

	useEffect(() => {
		if (!openMenu) return;
		const handleClickOutside = (e) => {
			if (barRef.current && !barRef.current.contains(e.target)) {
				setOpenMenu(null);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [openMenu]);

	const handleMenuClick = (item, window) => {
		if (item.submenu) {
			setOpenMenu(openMenu === item.label ? null : item.label);
		} else {
			if (item.fAction) {
				item.fAction(window);
			}
			if (item.action) {
				onMenuClick(item.action, window);
			}
			setOpenMenu(null);
		}
	};

	return (
		<div className="menubar" ref={barRef}>
			{menu.map((item, index) => (
				(item?.submenu && item.submenu.length > 0 &&
				<div key={index} className="menuitem" onClick={() => handleMenuClick(item)}>
					{item.label}
					{item.submenu && openMenu === item.label && (
						<div className="submenu">
							{[...item.submenu].sort((a, b) => (a.menuOrder || 0) - (b.menuOrder || 0)).
								map((subItem, subIndex) => (
								<div
									key={subIndex}
									className="submenuitem"
									onClick={() => handleMenuClick(subItem, window)}
								>
									<span className="submenuitemicon">{subItem.icon}{subItem.checked ? '✓ ' : ''}</span>
									{subItem.label}
								</div>
							))}
						</div>
					)}
				</div>
			)))}
			<div style={{flexGrow: 1}} onClick={() => setOpenMenu(null)}> </div>
		</div>
	);
};

export default MenuBar;
